import React, { useEffect, useState } from "react";
import { ProductSelector, Product, CustomDimensionsForm } from "../imports";

export default function Products(props) {
  const [products, setProducts] = useState([]);
  useEffect(() => {
    ProductSelector.loadProducts((prods) => setProducts(prods));
  }, []);
  const productElements = products.map((product) => (
    <Product
      key={product.id}
      product={product}
      dimensions={props.dimensions}
      selectedProduct={props.selectedProduct}
      setSelectedProduct={props.setSelectedProduct}
    />
  ));
  return (
    <div id="threekit-products">
      {productElements}
      <CustomDimensionsForm
        products={products}
        {...props.dimensions}
        selectedProduct={props.selectedProduct}
        setSelectedProduct={props.setSelectedProduct}
      />
    </div>
  );
}
